import React from 'react';
import { Link } from 'react-router-dom';
import './CallToActionSection.css';

const CallToActionSection = () => {
    return (
        <section className="cta-section">
            <div className="cta-container">
                <div className="cta-content">
                    <h2 className="cta-heading">
                        Prepare for Your Future in
                        <span className="highlight-text"> Defence & Competitive Exams</span>
                    </h2>
                    <p className="cta-description">
                        Expert guidance, structured preparation, and comprehensive support for 
                        NDA, CDS, AFCAT, and other competitive examinations.
                    </p>
                    <div className="cta-features">
                        <div className="feature">
                            <span className="feature-icon">🎯</span>
                            <span className="feature-text">Specialized Training Programs</span>
                        </div>
                        <div className="feature">
                            <span className="feature-icon">📚</span>
                            <span className="feature-text">Mock Tests & Assessments</span>
                        </div>
                        <div className="feature">
                            <span className="feature-icon">👥</span>
                            <span className="feature-text">One-on-One Mentoring</span>
                        </div>
                    </div>
                    <Link to="/contact" className="cta-button">
                        Start Your Preparation
                        <span className="button-arrow">→</span>
                    </Link>
                </div>
                <div className="cta-image-container" style={{
                    backgroundImage: `url('/images/calltoaction.jpg')`
                }}>
                    <div className="image-overlay"></div>
                </div>
            </div>
        </section>
    );
};

export default CallToActionSection;
